import React, { useState } from 'react'
import {connect} from 'react-redux'
import {addCameraToView, showAlertModal} from '../../actions'
import Dialog from '../common/Dialog'

const SelectCamera = props => {
  const {
    slotId,
    compositeCams,
    cameras,
    addCameraToView,
    showAlertModal,
  } = props
  const [showCameraSelection, setShowCameraSelection] = useState(false)
  const [cameraList, setCameraList] = useState([])
  const [selectedCamera, setSelectedCamera] = useState('')

  const handleClick = async () => {
    // filter those already in compositeCams
    const cams = await cameras.filter(c => c.bProfile === 1 && c.fEnabled === 1 && !compositeCams.includes(c.bID))
    setCameraList(cams)
    setShowCameraSelection(true)
  }

  const resetSelection = () => {
    setSelectedCamera('')
    setShowCameraSelection(false)
  }

  const saveCameraSelection = (e) => {
    e.preventDefault()
    if (selectedCamera === '') {
      showAlertModal(['WARNING', 'Please select a camera first.'])
      return
    }

    addCameraToView(compositeCams, slotId, selectedCamera)
    resetSelection()
  }

  return (
    <div style={styles.container}>
      <div style={styles.box} onClick={handleClick}>
        <p>Select Camera</p>
      </div>

      {showCameraSelection &&
        <Dialog
          title="Select Camera"
          boxStyle={{width: '50vmin'}}
          content={(
            <select onChange={e => setSelectedCamera(e.target.value)} style={styles.select} >
              <option value=''>Please select</option>
              {cameraList.map(c => (<option key={c.bID} value={c.bID}>{c.label}</option>))}
            </select>
          )}
          buttons={[
            {label: 'Ok', onClick: saveCameraSelection},
            {label: 'Cancel', onClick: resetSelection}
          ]}
        />
      }
    </div>
  )
}

const mapStateToProps = state => {
  const { selectedUserView, compositeCams, cameras } = state.data
  return {
    selectedUserView,
    compositeCams,
    cameras,
  }
}
export default connect(mapStateToProps, {addCameraToView, showAlertModal})(SelectCamera)

const styles = {
  container: {
    position: 'relative',
    top: '40%',
    width: '100%',
    textAlign: 'center',
  },
  box: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.5)',
    borderRadius: 10,
    margin: 'auto',
    width: '90%',
    maxWidth: 260,
    cursor: 'pointer',
    fontSize: 12,
  },
  select: {
    maxWidth: '40vmin',
  },
};
